import * as S from './styles';

export interface StepHeadingInfo {
	number: string;
	label: string;
}

export const parseStepHeading = (message: string): StepHeadingInfo | null => {
	const match = message.match(/<step-heading[^>]*\/>/);
	if (!match) return null;
	const parser = new DOMParser();
	const doc = parser.parseFromString(match[0], 'text/xml');
	const el = doc.querySelector('*|step-heading');
	if (!el) return null;
	const number = el.getAttribute('number');
	const label = el.getAttribute('label');
	if (!number || !label) return null;
	return { number, label };
};

interface Props {
	number: string;
	label: string;
}

const StepHeading = ({ number, label }: Props) => {
	return (
		<S.Base>
			<S.Eyebrow>Step</S.Eyebrow>
			<S.Row>
				<S.Badge>{number}</S.Badge>
				<S.Label>{label}</S.Label>
			</S.Row>
		</S.Base>
	);
};

export default StepHeading;
